/**
 * @file 取り組みの記録 (progress logs) の並べ方を置く。
 *
 * @what: 記録の日付 (date、YYYY-MM-DD) の新しい順に並べ、同じ日付の中は残した順
 *   (created_at の新しい順) にする。
 * @why: API は created_at の新しい順で返すので、過去の日付で後から足した記録が先頭に来て、
 *   その日付の場所に出なかった (代表の指摘、2026-09-08)。日付はサーバでは並べ替えられない
 *   (暗号化ペイロードの中) ので、読み込んだぶんを client で並べ直す。
 * @failure: 純関数である。date が欠けた記録は末尾に回す (落とさない)。
 */

import type { StudyProgressLog } from "../api/plans";

export function sortProgressLogsByDate(logs: readonly StudyProgressLog[]): StudyProgressLog[] {
  return [...logs].sort((a, b) => {
    const byDate = (b.date ?? "").localeCompare(a.date ?? "");
    if (byDate !== 0) return byDate;
    return (b.created_at ?? "").localeCompare(a.created_at ?? "");
  });
}
